module.exports = __webpack_public_path__ + "img/promotion_voucher_icon.b48f98eb.png";